import DayjsUtils from '@date-io/dayjs'
import {
	Divider,
	makeStyles, Table,
	TableBody,
	TableCell,
	TableHead,
	TablePagination,
	Box, IconButton,
	Container,
	TableRow,
	TextField,
	InputAdornment,
	SvgIcon,
} from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Radio from '@material-ui/core/Radio'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import TableContainer from "@material-ui/core/TableContainer"
import Tooltip from '@material-ui/core/Tooltip'
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"
import * as dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useSnackbar } from 'notistack';
import { useActions, useValues } from 'kea';
import AddIcon from '@material-ui/icons/Add';
import { Search as SearchIcon } from "react-feather";
import Fuse from 'fuse.js';

import vehiclelogic from 'src/store/vehicle'
import { rstationarylogic } from 'src/store/report'
import { minHistoryDate } from 'src/utils/constants';

const useStyles = makeStyles({
	root: {
		width: "100%"
	},
	container: {
		maxHeight: '440'
	}
});

const columns = [
	{
		field: 'type',
		headerName: 'Type',
		align: 'left',
		width: 100,
	},
	{
		field: 'registration_number',
		headerName: 'Registration Number',
		align: 'left',
		width: 100,
	},
	{
		field: 'name',
		headerName: 'Name',
		align: 'left',
		width: 250,
	},
	{
		field: 'info',
		headerName: 'Vehicle Details',
		align: 'left',
		width: 250,
	},
	{
		field: 'actions',
		headerName: 'Actions',
		align: 'right',
		width: 100,
	}
];

const initialStationaryDataParam = {
	vehicle: '',
	start: dayjs().startOf('day'),
	stop: dayjs().endOf('day')
}

const StationaryDataDialog = () => {
	const classes = useStyles();
	const { enqueueSnackbar } = useSnackbar();

	const { vehicles } = useValues(vehiclelogic);
	const { fetchAll: vehicleFetchAll } = useActions(vehiclelogic);

	const { fetch } = useActions(rstationarylogic);

	const [stationaryDataParam, setStationaryDataParam] = useState(initialStationaryDataParam);
	const [open, setOpen] = React.useState(false);
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);

	const [filtered, setFiltered] = useState([]);
	const [search, setSearch] = useState('');

	useEffect(() => {
		vehicles ?? vehicleFetchAll();
	}, []) // eslint-disable-line

	useEffect(() => {
		if (search === '') {
			setFiltered(vehicles || []);
		} else {
			const fuse = new Fuse(vehicles, {
				keys: ['name', 'registration_number', 'tracker.serial'],
				threshold: 0.0,
				ignoreLocation: true
			});
			let found = fuse.search(search);
			found = found.map(item => {
				item.item.refIndex = item.refIndex;
				return item.item;
			});
			setFiltered(found);
		}
	}, [vehicles, search])// eslint-disable-line

	if (vehicles === null) {
		return (
			<></>
		)
	}
	const emptyRows = rowsPerPage - Math.min(rowsPerPage, vehicles.length - page * rowsPerPage);

	const handleChangePage = (even, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};


	const handleClickOpen = () => {
		setOpen(true);
	}

	const handleClose = () => {
		setOpen(false);
	}

	const handleAdd = () => {
		if (!stationaryDataParam.vehicle) {
			enqueueSnackbar('Please Select a Vehicle', { variant: 'error' });
			return
		}
		if (dayjs(stationaryDataParam.start).isAfter(stationaryDataParam.stop)) {
			enqueueSnackbar('Please enter correct dates', { variant: 'error' });
			return
		}
		addDataHandler(stationaryDataParam);
		setStationaryDataParam(initialStationaryDataParam);
		handleClose();
	}

	const handleChange = (key, value) => {
		let updatedParams = { ...stationaryDataParam };
		updatedParams[key] = value;
		setStationaryDataParam(updatedParams);
	}

	const handleHotKey = (period, value, lastdays = true) => {
		let updatedParams = { ...stationaryDataParam };
		if (period === 'month') {
			updatedParams.start = dayjs().subtract(value, 'month').startOf('month');
			updatedParams.stop = dayjs().subtract(value, 'month').endOf('month')
		} else if (period === 'week') {
			updatedParams.start = dayjs().subtract(value, 'week').startOf('week');
			updatedParams.stop = dayjs().subtract(value, 'week').endOf('week');
		} else if (period === 'day') {
			updatedParams.start = dayjs().subtract(value, 'day').startOf('day');
			updatedParams.stop = lastdays ? dayjs().subtract(value, 'day').endOf('day') : dayjs().endOf('day');
		}
		setStationaryDataParam(updatedParams);
	}

	const addDataHandler = (new_data) => {
		fetch(new_data);
	}

	const handleSearch = (e) => setSearch(e.target.value);

	return (
		<>
			<Tooltip title="Generate Report">
				<IconButton aria-label="add" onClick={handleClickOpen}>
					<AddIcon />
				</IconButton>
				{/* <Button
					color="primary"
					variant="contained"
					aria-label="add"
					onClick={handleClickOpen}
				>
					Generate Report
				</Button> */}
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
				maxWidth='xl'
			>
				<DialogTitle id="form-dialog-title">Generate Report</DialogTitle>
				<DialogContent>
					{/* <DialogContentText>Add Vehicle</DialogContentText> */}
					<TextField
						fullWidth
						style={{
							paddingBottom: '20px'
						}}
						className={classes.SearchWithToggle}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<SvgIcon fontSize="small" color="action">
										<SearchIcon />
									</SvgIcon>
								</InputAdornment>
							),
						}}
						onChange={handleSearch}
						placeholder="Search Vehicles"
						variant="outlined"
					/>

					<div style={{ height: '100%', width: '100%', background: 'white' }}>
						<TableContainer className={classes.container}>
							<Table stickyHeader aria-label="sticky table" size={'small'}>
								<TableHead>
									<TableRow>
										{columns.map((column) => (
											<TableCell
												key={column.field}
												align={column.align}
												style={{ minWidth: column.width }}
											>
												{column.headerName}
											</TableCell>
										))}
									</TableRow>
								</TableHead>
								<TableBody>
									{
										filtered && filtered.length > 0 ?
											filtered
												.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
												.map((row) => {
													if (!row.tracker) return null;
													return (
														<TableRow hover role="checkbox" tabIndex={-1} key={row._id}>
															{columns.map((column) => {
																if (column.field === 'enabled') {
																	return (
																		<TableCell key={column.field} align={column.align}>
																			{
																				row[column.field] ?
																					'Enabled'
																					:
																					'Disabled'
																			}
																		</TableCell>
																	)
																}
																if (column.field === 'actions') {
																	return (
																		<>
																			<TableCell key={column.field} align={column.align}>
																				<Radio
																					color="primary"
																					inputProps={{ 'aria-label': 'secondary checkbox' }}
																					checked={stationaryDataParam.vehicle === row._id}
																					onChange={() => handleChange('vehicle', row._id)}
																				/>
																			</TableCell>
																		</>
																	)
																}
																if (column.field === 'info') {
																	return (
																		<>
																			<TableCell key={column.field} align={column.align}>
																				{`${row.year} ${row.company} ${row.model} ${row.color}`}
																			</TableCell>
																		</>
																	)
																}
																const value = row[column.field];
																return (
																	<TableCell key={column.field} align={column.align}>
																		{column.format && typeof value === "number"
																			? column.format(value)
																			: value}
																	</TableCell>
																);
															})}
														</TableRow>
													);
												})
											: <TableRow>
												<TableCell style={{ height: 61 * rowsPerPage }} colSpan={5} align={'center'}>
													No Data Added.
												</TableCell>
											</TableRow>
									}
									{
										vehicles.length > 0 && emptyRows > 0 && (
											<TableRow style={{ height: 61 * emptyRows }}>
												<TableCell colSpan={6} />
											</TableRow>
										)
									}
								</TableBody>
							</Table>
						</TableContainer>
						{/* </Paper> */}
					</div>
				</DialogContent>
				<DialogActions>
					{/* <Tooltip title="Add multiple">
						<Switch
							checked={switchState.addMultiple}
							onChange={handleSwitchChange('addMultiple')}
							value="addMultiple"
							inputProps={{ 'aria-label': 'secondary checkbox' }}
						/>
					</Tooltip> */}
					<Container maxWidth={false}>
						<Box>
							<TablePagination
								rowsPerPageOptions={[10, 15, 20]}
								component="div"
								count={vehicles ? vehicles.length : 0}
								rowsPerPage={rowsPerPage}
								page={page}
								onChangePage={handleChangePage}
								onChangeRowsPerPage={handleChangeRowsPerPage}
							/>
							<Divider />
						</Box>
						<Box>
							<div style={{ paddingTop: '15px', paddingBottom: '15px', width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
								<div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start' }}>
									<Button onClick={() => handleHotKey('day', 30, false)} color="primary">
										Last 30 Days
									</Button>
									<Button onClick={() => handleHotKey('month', 1)} color="primary">
										Last Month
									</Button>
									<Button onClick={() => handleHotKey('week', 1)} color="primary">
										Last Week
									</Button>
									<Button onClick={() => handleHotKey('day', 1)} color="primary">
										Last Day
									</Button>
								</div>
								<div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
									<div style={{ minWidth: '50px' }} >
										<MuiPickersUtilsProvider utils={DayjsUtils}>
											<DateTimePicker
												autoOk
												ampm={false}
												variant="inline"
												label="Start"
												minDate={minHistoryDate}
												value={stationaryDataParam.start}
												onChange={(value) => handleChange('start', value)}
												disableFuture
											/>
										</MuiPickersUtilsProvider>
									</div>
									<div style={{ minWidth: '50px' }} />
									<MuiPickersUtilsProvider utils={DayjsUtils}>
										<DateTimePicker
											autoOk
											ampm={false}
											variant="inline"
											label="Stop"
											value={stationaryDataParam.stop}
											onChange={(value) => handleChange('stop', value)}
											disableFuture
											minDate={stationaryDataParam.start}
											minDateMessage={'Date should not be before \'Start date\''}
										/>
									</MuiPickersUtilsProvider>
								</div>
							</div>
							<Divider />
						</Box>
						<Box>
							<div style={{ paddingTop: '15px', paddingBottom: '15px', width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
								<Button onClick={handleClose} color="primary">
									Cancel
								</Button>
								<Button onClick={handleAdd} color="primary">
									Generate
								</Button>
							</div>
						</Box>
					</Container>
				</DialogActions>
			</Dialog >
		</ >
	)
}

StationaryDataDialog.propTypes = {
}

export default StationaryDataDialog
